import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { useRouter } from '@mi-front/core';
import EditIcon from '@mui/icons-material/Edit';
import { Button, Stack } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { useComposition } from '../hooks/useComposition';
import { ComposeViewOverflowActions } from './ComposeViewOverflowActions';

const composeEditActionMessage = defineMessage({
  id: 'common.actions.edit',
  defaultMessage: 'Editar',
});

/**
 * Header actions for the composition detail page: edit button and overflow menu (delete).
 */
export function ComposeViewActions() {
  const { composition, station } = useComposition();
  const { history } = useRouter();
  const { $t } = useIntl();

  const handleEdit = () => {
    history.push(composeRouteGenerator.edit(composition.id));
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Button size="small" variant="outlined" startIcon={<EditIcon />} onClick={handleEdit}>
        {$t(composeEditActionMessage)}
      </Button>
      {station ? <ComposeViewOverflowActions station={station} /> : null}
    </Stack>
  );
}
